import React, {useState} from 'react';
import Controls from 'controls';
import {INonMember} from 'types/nonMember';
import {PublicEventType} from 'enums/public_event_type';
import {EditNonMember} from './EditNonMember';
import {SignNonMemberProfile} from './SignNonMemberProfile';
import {PreviewProfile} from './PreviewProfile';

interface NonMemberProps {
  onCancel: () => void;
  facility: string;
  currEventType: PublicEventType;
  eventIdToBook: string;
  eventDate: string;
}

export enum ModalViewEnum {
  CREATE = 'Create',
  SIGN = 'Sign',
  PREVIEW = 'Preview',
}

export const NonMember = (props: NonMemberProps) => {
  const [view, setView] = useState<ModalViewEnum>(ModalViewEnum.CREATE);
  const [lead, setLead] = useState<Partial<INonMember>>({});

  const title = getModalTitle(view);

  return (
    <Controls.Modal
      onClose={[ModalViewEnum.PREVIEW, ModalViewEnum.SIGN].includes(view) ? undefined : props.onCancel}
      size="large"
      title={title}
      selfAlign="center">
      {view === ModalViewEnum.CREATE && (
        <EditNonMember
          lead={lead}
          setView={setView}
          setLead={setLead}
          onCancel={props.onCancel}
          type={props.currEventType}
        />
      )}
      {view === ModalViewEnum.PREVIEW && <PreviewProfile setView={setView} lead={lead} />}
      {view === ModalViewEnum.SIGN && (
        <SignNonMemberProfile
          setView={setView}
          eventId={props.eventIdToBook}
          date={props.eventDate}
          onCancel={props.onCancel}
          lead={{...lead, leadRequestLocation: props.facility}}
        />
      )}
    </Controls.Modal>
  );
};

function getModalTitle(view: ModalViewEnum) {
  switch (view) {
    case ModalViewEnum.CREATE:
      return 'Non-Member Details';
    case ModalViewEnum.PREVIEW:
      return 'Customer Profile';
    case ModalViewEnum.SIGN:
      return 'Sign Customer Profile';
    default:
      return 'Book Type';
  }
}
